import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    border: "1px solid #E2E2E2",
    borderRadius: 4,
    width: "100%",
    minHeight: 54,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 13px",
    marginBottom: 13,
    cursor: "pointer",
  },
  contentContainer: {
    backgroundColor: "#fff",
    width: "100%",
    minHeight: 54,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 13px",
    marginBottom: 13,
    paddingTop: 18,
    cursor: "pointer",
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    lineHeight: 1.2,
    // [theme.breakpoints.down("sm")]: {
    //   marginLeft: theme.spacing(1),
    //   overflow: "hidden",
    // },
  },
  description: {
    overflow: "hidden",
    textOverflow: "ellipses",
    maxHeight: 50,
    lineHeight: 1.2,
  },
  server: {
    display: "flex",
    justifyContent: "left",
  },
  updated: {
    display: "flex",
    justifyContent: "left",
  },
  removeButton: {
    color: theme.palette.warning.main,
  },
}))

export default styles
